import {DataSource} from '@angular/cdk/table';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {catchError, finalize, take, takeUntil} from 'rxjs/operators';
import {CollectionViewer} from '@angular/cdk/collections';

import {Branch} from '../branch.model';
import {BranchService} from '../branch.service';


export class BranchListDataSource extends  DataSource<Branch> {

  private branchSubject = new BehaviorSubject<Branch[]>([]);
  public totalCount$ = new BehaviorSubject<number>(0);

  constructor(private branchService: BranchService) { super(); }

  connect(collectionViewer: CollectionViewer): Observable<Branch[]> {
    return this.branchSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.branchSubject.complete();
    this.totalCount$.complete();
  }

  loadBranchs(sortDirection = 'asc', pageIndex = 0, pageSize = 10) {
    this.branchService.findBranchs({
      page: pageIndex,
      size: pageSize,
      sort: sortDirection,
    }).pipe(
      catchError(() => of([])),
      finalize(() => {})
    ).pipe(take(1)).subscribe((response) => {
      this.totalCount$.next(response['headers'].get('X-Total-Count'));
      this.branchSubject.next(response['body']);
    });
  }

}
